<script>
  import { supabase } from "./supabaseClient";
  import Constant from "./Constant";
  import { onMount } from "svelte";
  let isAuth = false;

  let memberId = "";
  let name = "";
  let comment = "";
  let color = "0";
  let reloadInterval = "0";
  let reloadIntervalId = "";
  let ipAddress = "";
  let isDeny = false;
  export let reload;

  /**
   * チャットに参加する
   */
  const join = async () => {
    if (isDeny) {
      alert(
        "現在入室が制限されています。心当たりの無い方は、お手数ですが管理者までご連絡下さい。"
      );
      return;
    }
    if (name === "") {
      alert("名前を入力してください。");
      return;
    }
    if (name.length > 20) {
      alert("名前は20文字以内にしてください。");
      return;
    }

    //メンバーの参加状況を更新
    memberId = await createMember();
    if (!memberId) {
      return;
    }
    if (!(await addCurrentMember())) {
      return;
    }
    //参加ログを登録
    try {
      const joinComment = {
        member_id: memberId,
        type: Constant.COMMENT_TYPE.JOIN,
      };
      let { error } = await supabase
        .from("comment")
        .insert(joinComment)
        .single();
      if (error) throw error;
    } catch (error) {
      alert(error.message);
    }

    /**
     * 一定間隔毎にユーザーのログイン状態を更新
     */
    setInterval(() => {
      updateCurrentMember();
    }, 1000 * 30);
    reload();
    isAuth = true;
  };

  /**
   * メンバー情報をDBに追加
   */
  const createMember = async () => {
    try {
      const member = {
        name,
      };

      let { data, error } = await supabase
        .from("member")
        .insert(member)
        .single();
      if (error) throw error;
      return data.member_id;
    } catch (error) {
      alert(error.message);
    }
    return null;
  };
  /**
   * 現在チャットに参加中のメンバーを追加
   */
  const addCurrentMember = async () => {
    try {
      const currentMember = {
        member_id: memberId,
        ip_address: ipAddress,
      };

      let { error } = await supabase
        .from("current_member")
        .insert(currentMember);
      if (error) throw error;
      return true;
    } catch (error) {
      alert(error.message);
    }
    return false;
  };

  /**
   * 発言／リロードする
   */
  const makeComment = async () => {
    if (comment === "") {
      reload();
      return;
    }
    if (comment.length > 50) {
      alert("発言は50文字以内にしてください。");
      return;
    }

    try {
      const commentRecord = {
        member_id: memberId,
        comment,
        color,
      };

      let { error } = await supabase.from("comment").insert(commentRecord);
      if (error) throw error;
    } catch (error) {
      alert(error.message);
    }
    comment = "";
    reload();
  };

  /**
   * 自分の参加状態を更新
   */
  const updateCurrentMember = async () => {
    try {
      const currentMember = {
        updated_at: "now()",
      };

      let { error } = await supabase
        .from("current_member")
        .update(currentMember)
        .eq("member_id", memberId);
      if (error) throw error;
    } catch (error) {
      alert(error.message);
    }
  };

  /**
   * チャットから退室
   */
  const leave = async () => {
    if (!confirm("退室しますか？")) {
      return;
    }
    try {
      //チャットの参加状態を更新
      const currentMember = {
        updated_at: "now()",
        removed: "true",
      };
      let { error } = await supabase
        .from("current_member")
        .update(currentMember)
        .eq("member_id", memberId);
      if (error) throw error;
    } catch (error) {}

    //退室ログを登録
    try {
      const joinComment = {
        member_id: memberId,
        type: Constant.COMMENT_TYPE.LEAVE,
      };
      let { error } = await supabase
        .from("comment")
        .insert(joinComment)
        .single();
      if (error) throw error;
    } catch (error) {
      alert(error.message);
    }
    color = "0";
    if (!reloadIntervalId) {
      clearInterval(reloadIntervalId);
    }
    comment = "";
    name = "";
    reloadInterval = "0";
    isAuth = false;
    reload();
  };

  const changeReloadInterval = (e) => {
    const intervalSec = Number(e.target.value);
    if (!reloadIntervalId) {
      clearInterval(reloadIntervalId);
    }
    if (intervalSec === 0) {
      return;
    }
    reloadIntervalId = setInterval(() => {
      reload();
    }, 1000 * intervalSec);
  };

  onMount(async () => {
    //IPアドレスを取得しておく
    const networkInfo = await fetch("https://api.ipify.org?format=json").then(
      (res) => res.json()
    );
    if (!networkInfo.ip) {
      return;
    }
    ipAddress = networkInfo.ip;

    //ブラックリストの中身を確認
    try {
      let { data, error } = await supabase
        .from("blacklist")
        .select("*")
        .eq("ip_address", ipAddress);
      if (error) throw error;

      if (data.length === 0) {
        return;
      }
      isDeny = true;
    } catch (error) {
      alert(error);
    }
  });
</script>

<div>
  {#if isAuth}
    <div class="controller">
      <div class="row">
        <label class="itemName" for="">名前</label>
        <span class="item">{name}</span>
      </div>
      <div class="row">
        <label class="itemName" for="">発言</label>
        <input type="text" class="item comment" bind:value={comment} />
      </div>
      <div class="row">
        <label class="itemName" for="">文字色</label>
        <select class="item" bind:value={color}>
          {#each Constant.COLORS as color, i}
            <option value={i}>{color.name}</option>
          {/each}
        </select>
        <label class="itemName" for="">自動リロード間隔</label>
        <select
          class="item"
          bind:value={reloadInterval}
          on:change={(e) => changeReloadInterval(e)}
        >
          <option value="0">手動</option>
          <option value="15">15秒</option>
          <option value="30">30秒</option>
          <option value="45">45秒</option>
          <option value="60">60秒</option>
        </select>
      </div>
      <div class="row">
        <button on:click={makeComment}>発言／リロード</button>
        <button on:click={leave} class="leave">退室</button>
      </div>
    </div>
  {:else}
    <div class="entrance">
      <label for="">名前</label>
      <input type="text" class="name" bind:value={name} />
      <button on:click={join}>入室</button>
    </div>
  {/if}
</div>

<style>
  .entrance {
    display: flex;
    height: 32px;
    align-items: center;
    padding: 10px;
  }
  .entrance > * {
    margin-right: 10px;
  }
  .name {
    width: 200px;
  }

  .controller {
    display: flex;
    flex-direction: column;
    padding: 10px;
  }
  .row {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-bottom: 3px;
    align-items: center;
  }
  .itemName,
  .item {
    margin-right: 5px;
  }
  .comment {
    flex-grow: 1;
    max-width: 600px;
  }
  .leave {
    margin-left: 10px;
  }
</style>
